import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

export const sliderSetting = {
  // This is horizontal slider setting code Start
  horizontalSlider: {
    dots: false,
    arrows: false,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 1600,
    speed: 1600,
    centerPadding: "60px",
    className: "center",
    centerMode: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    initialSlide: 1,
    rows: 1,
    slidesPerRow: 1,
    responsive: [
      {
        breakpoint: 9999,
        settings: "unslick",
      },
      {
        breakpoint: 992,
        settings: "unslick",
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          autoplaySpeed: 3100,
          speed: 2900,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 1,
          centerMode: false,
          autoplaySpeed: 3000,
          speed: 3000,
        },
      },

      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 0,
          centerMode: false,
          autoplaySpeed: 3000,
          speed: 3000,
        },
      },
      {
        breakpoint: 379,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerPadding: "0px",
          className: "center",
          centerMode: false,
          autoplaySpeed: 3000,
          speed: 3000,
        },
      },
    ],
  },
  // This is horizontal slider setting code End

  // This is vertical slider setting code Start
  verticalSlider: {
    dots: false,
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    vertical: true,
    verticalSwiping: true,
    adaptiveHeight: true,
    beforeChange: function (currentSlide, nextSlide) {
      console.log("before change", currentSlide, nextSlide);
    },
    afterChange: function (currentSlide) {
      console.log("after change", currentSlide);
    },
    responsive: [
      {
        breakpoint: 9999,
        settings: "unslick",
      },
      {
        breakpoint: 992,
        settings: "unslick",
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  },
  // This is vertical slider setting code end
};
